import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const ListPetitions = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [petitionStatuses] = useState([
    'SUBMISSION',
    'REGISTRATION',
    'PRELIMINARY INVESTIGATION',
    'REFERRAL',
    'MONITORING',
    'CLOSED',
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/petitions/list`);

        setNews(response.data);
      } catch (error) {
        // console.log('error', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const UpdateStatus = async (petitionId, status) => {
    try {
      setLoading(true);
      setError(null);

      const newsUpdated = news.map((item) => {
        if (item.petitionId === petitionId) {
          return { ...item, status: status };
        } else {
          return item;
        }
      });

      setNews(newsUpdated);

      await axios.put(`${process.env.REACT_APP_API_URL}/petitions/id/${petitionId}`, {
        petitionId,
        status,
      });

      setLoading(false);
    } catch (error) {
      console.log('error', error);
      setError(error.message);
    }
  };

  const prettyDate = (zuluDate) => {
    const date = new Date(zuluDate);

    const formattedDate = `${date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })} ${date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })}`;

    return formattedDate;
  };

  return (
    <>
      <PageHeader title="List of Petitions" description="" className="mb-3"></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <Table hover responsive>
          <thead>
            <tr>
              <th scope="col">Petition ID</th>
              <th scope="col">Department</th>
              <th scope="col">Title</th>
              <th scope="col">Petitioner</th>
              <th scope="col">Date Submitted</th>
              <th scope="col">Stage</th>
              <th className="text-end" scope="col">
                Change Stage
              </th>
            </tr>
          </thead>
          <tbody>
            {news.map((item, index) => (
              <tr key={index}>
                <td>
                  <Link to={`/petition/${item.petitionId}`}>{item.petitionId}</Link>
                </td>
                <td>{item.department}</td>
                <td>{item.petitionTitle}</td>
                <td>{item.fullName}</td>
                <td>{prettyDate(item.dateSentToPetitionsUnit)}</td>
                <td>{item.status}</td>
                <td className="text-end">
                  <select
                    className="form-select"
                    name="status"
                    onChange={(e) => UpdateStatus(item.petitionId, e.target.value)}
                    selected={item.status}
                  >
                    {petitionStatuses.map((status, index) => (
                      <option key={index} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ListPetitions;
